/** 统一登录跳转,保留 redirect */
export function authLoginPath(redirect?: string | null): string {
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return `/auth/login?redirect=${encodeURIComponent(redirect)}`
  }
  return '/auth/login'
}

export function authRegisterPath(redirect?: string | null): string {
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return `/auth/register?redirect=${encodeURIComponent(redirect)}`
  }
  return '/auth/register'
}

export function authForgotPasswordPath(redirect?: string | null): string {
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return `/auth/forgot-password?redirect=${encodeURIComponent(redirect)}`
  }
  return '/auth/forgot-password'
}
